import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-sectors',
  templateUrl: './edit-sectors.component.html',
  styleUrls: ['./edit-sectors.component.scss']
})
export class EditSectorsComponent implements OnInit {

  productId: string | null = null;
  previewUrl: string | null = null;

  product: any = {
    title_ar: '',
    title_en: '',
    description_ar: '',
    description_en: '',
    icon: null as File | string | null,
  };

  pages: any[] = [];
  InvestorsId: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService,
    public _translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.productId = this.route.snapshot.paramMap.get('id');
    if (this.productId) {
      this.loadProduct(this.productId);
    }
    this.getContractTypes();
    this.getInvestorsId();
  }

  // ✅ دالة مساعدة: هل نعرض الصورة الحالية؟
  get showCurrentLogo(): boolean {
    return !!this.product.icon && 
           typeof this.product.icon === 'string' && 
           !this.previewUrl;
  }

  getContractTypes(): void {
    this.apiService.contractsType().subscribe({
      next: (response: any) => {
        this.pages = response.data || [];
      },
      error: (error) => console.error('Failed to load contract types:', error),
    });
  }

  loadProduct(id: string): void {
    this.apiService.getSectorsById(id).subscribe({
      next: (res: any) => {
        if (res?.data) {
          const data = res.data;
          this.product = {
            title_ar: data.title_ar || data.title || '',
            title_en: data.title_en || data.title || '',
            description_ar: data.description_ar || data.description || '',
            description_en: data.description_en || data.description || '',
            icon: data.icon || null,
          };
        }
      },
      error: (err) => {
        console.error('Failed to load product:', err);
        this.toastr.error(this._translateService.instant('MENU.DASHBOARD.failed_to_load'));
      },
    });
  }

  onFileSelected(event: any): void {
    if (event.target.files?.length > 0) {
      const file = event.target.files[0];
      this.product.icon = file;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.previewUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  removeCurrentLogo(): void {
    this.product.icon = null;
    this.previewUrl = null;
  }

  removeNewLogo(): void {
    this.previewUrl = null;
    if (!(this.product.icon instanceof File)) {
      this.product.icon = null;
    }
    const fileInput = document.getElementById('logoUpload') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
  }

  getInvestorsId(): void {
    this.apiService.investors().subscribe({
      next: (response: any) => {
        this.InvestorsId = response.data;
      },
      error: (error) => console.log(error),
    });
  }

  updateProduct(): void {
    if (!this.productId) {
      this.toastr.error(this._translateService.instant('MENU.DASHBOARD.missing_id'));
      return;
    }

    if (!this.product.title_ar || !this.product.title_en || 
        !this.product.description_ar || !this.product.description_en) {
      this.toastr.error(this._translateService.instant('MENU.DASHBOARD.all_fields_required'));
      return;
    }

    const formData = new FormData();
    formData.append('title_ar', this.product.title_ar?.trim());
    formData.append('title_en', this.product.title_en?.trim());
    formData.append('description_ar', this.product.description_ar?.trim());
    formData.append('description_en', this.product.description_en?.trim());

    if (this.product.icon instanceof File) {
      formData.append('icon', this.product.icon);
    }

    this.apiService.editSectors(this.productId, formData).subscribe({
      next: () => {
        this.toastr.success(this._translateService.instant('MENU.DASHBOARD.updated_successfully'));
        this.router.navigate(['/sectors']);
      },
      error: (err) => {
        console.error('Update failed:', err);
        if (err.error?.errors) {
          Object.keys(err.error.errors).forEach(key => {
            this.toastr.error(err.error.errors[key][0]);
          });
        } else {
          this.toastr.error(this._translateService.instant('MENU.DASHBOARD.failed_to_update_status'));
        }
      },
    });
  }
}